import { useContext, useEffect, useState } from 'react'
import CTFCloseIntentModal from '../CTFCloseIntentModal'
import CortFormButton from '../Preview/components/CortFormButton'
import Sidebar from '../Sidebar'
import { captureEvent } from '../../analytics'
import { analyticsEvents } from '../../analytics/events'
import Result, { EResult } from '../Sidebar/components/ContactForm/components/Result'
import { useParentWindowEvent } from '../../hooks/useParentWindowEvent'
import { AppConfigContext } from '../../context/AppConfig'
import EversetCheckoutModal from '../EversetCheckoutModal'
import VariantWrapper from '../VariantWrapper'
import { variants } from '../../constants/variant'
import { useStore } from '../../store'
import ScreenType from '../ScreenType'

export default function CTFSidebar() {
  const [toggled, setToggled] = useState(false)
  const [hidden, setHidden] = useState(true)
  const [ctfCloseIntentModalShown, setCTFCloseIntentModalShown] = useState(false)
  useEffect(() => {
    if (toggled) {
      setHidden(false)
    } else {
      setTimeout(() => {
        setHidden(true)
      }, 170)
    }
  }, [toggled])

  useParentWindowEvent({
    onClose: () => {
      setCTFCloseIntentModalShown(true)
    },
  })

  const [formResult, setFormResult] = useState()

  const [exitIntentFormResult, setExitIntentFormResult] = useState()

  const { isEWApp, isSWApp, as_staging, mimicVariant } = useContext(AppConfigContext)

  const [checkoutModalShown, setCheckoutModalShown] = useState(false)

  const { data } = useStore()

  const propertyName = data?.property?.property_name?.toLowerCase() || ''

  const isSpecialProperty = (propertyName.indexOf('evoq') > -1 || propertyName.indexOf('demo') > -1) && isSWApp

  return (
    <>
      {ctfCloseIntentModalShown && !exitIntentFormResult && (
        <CTFCloseIntentModal
          onClose={(result) => {
            if (result) {
              setCTFCloseIntentModalShown(false)
              setExitIntentFormResult(result)
            } else {
              window.parent.postMessage({ event: 'widget-app:close' }, '*')
            }
          }}
        />
      )}

      {exitIntentFormResult && (
        <Result
          result={exitIntentFormResult}
          onClose={() => {
            if (exitIntentFormResult === EResult.SUCCESS) {
              setExitIntentFormResult(null)
              window.parent.postMessage({ event: 'widget-app:close' }, '*')
            } else {
              setExitIntentFormResult(null)
              setCTFCloseIntentModalShown(true)
            }
          }}
        />
      )}
      {checkoutModalShown && <EversetCheckoutModal className="fade-in" onClose={() => setCheckoutModalShown(false)} />}
      {!as_staging && mimicVariant !== variants.ev && !isSpecialProperty && data?.property && (
        <ScreenType>
          <CortFormButton
            onClick={() => {
              captureEvent(analyticsEvents.CONTACT_US_TAPPED)
              if (isEWApp) {
                window.open(`https://theeverset.com/cart`, '_blank')
                // setCheckoutModalShown(true)
                return
              }
              setToggled(true)
            }}
            className="absolute right-[24px] bottom-[50px] z-[100] hidden lg:flex"
          />
        </ScreenType>
      )}
      <div
        className={`fixed top-0 left-0  z-[100] transition-[opacity] duration-500 ${
          toggled ? 'opacity-100' : 'opacity-0'
        } ${!hidden ? 'h-[calc(100%-30px)] w-full' : 'h-0 w-0 overflow-hidden'}`}
      >
        {toggled && !formResult ? (
          <div
            className="bg-[rgba(0,0,0,.7)] absolute top-0 left-0 h-full w-full "
            onClick={() => {
              captureEvent(analyticsEvents.CORT_FORM_CLOSED)
              setToggled(false)
            }}
          ></div>
        ) : null}
        <Sidebar
          onToggle={(val) => {
            setFormResult(null)
            setToggled(null)
          }}
          onFormResult={setFormResult}
          onTransitionEnd={() => {
            if (toggled === null) {
              captureEvent(analyticsEvents.CORT_FORM_CLOSED)
              setToggled(false)
            }
          }}
          className={`h-full !absolute right-0 ${toggled === null ? '' : 'transition-all ease-in duration-150'}  ${
            toggled ? 'right-0' : 'right-[-340px]'
          } top-0`}
        />
      </div>
    </>
  )
}
